module.exports = __webpack_public_path__ + "13db92ce63008c45e46679bb87d4abaa.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/hand/tea-pot.png
// module id = 2137
// module chunks = 0